/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Missing_Team_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to sync Team Project. Your user does not belong to a team." |
*
* @param {Team_Sync_Missing_Team_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_missing_team_error = /** @type {((inputs?: Team_Sync_Missing_Team_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Missing_Team_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de synchroniser le projet d’équipe. Votre utilisateur n’appartient à aucune équipe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teamprojekt konnte nicht synchronisiert werden. Ihr Benutzer gehört keinem Team an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile sincronizzare Team Project. L'utente non appartiene a nessun team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось синхронизировать проект команды. Ваш пользователь не принадлежит ни к одной команде.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede sincronizar el proyecto de equipo. Tu usuario no pertenece a ningún equipo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法同步团队项目。您的用户不属于任何团队。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトを同期できません。ユーザーはチームに属していません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट को सिंक करने में असमर्थ। आपका उपयोगकर्ता किसी टीम का सदस्य नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível sincronizar o Projeto de Equipe. Seu usuário não pertence a uma equipe.")
	return /** @type {LocalizedString} */ ("Unable to sync Team Project. Your user does not belong to a team.")
});